export const DIET_KINDS = [
  { value: 'enteral', label: 'Enteral' },
  { value: 'oral', label: 'Oral' }
]

export const MEAL_PRESETS = [
  { name: 'Café da manhã', time: '07:00' },
  { name: 'Colação', time: '09:30' },
  { name: 'Almoço', time: '12:00' },
  { name: 'Lanche', time: '15:30' },
  { name: 'Jantar', time: '19:00' },
  { name: 'Ceia', time: '21:00' }
]

export const CONSISTENCIES = [
  { value: 'oral_solida', label: 'Oral — Sólida' },
  { value: 'oral_pastosa', label: 'Oral — Pastosa' },
  { value: 'oral_branda', label: 'Oral — Branda' },
  { value: 'oral_liquida', label: 'Oral — Líquida' },
  { value: 'enteral_sonda', label: 'Enteral — Sonda (SNG)' },
  { value: 'enteral_gtt', label: 'Enteral — Gastrostomia (GTT)' }
]

export const FOOD_UNITS = ['g', 'ml', 'un', 'colher de sopa', 'colher de chá', 'xícara', 'fatia', 'porção']

export const ROUTES = [
  { value: 'oral', label: 'Oral' },
  { value: 'sng', label: 'SNG' },
  { value: 'gtt', label: 'GTT' }
]

export const UNIT_OPTIONS = [
  { value: 'latas', one: 'lata', many: 'latas' },
  { value: 'frascos', one: 'frasco', many: 'frascos' },
  { value: 'unidades', one: 'unidade', many: 'unidades' }
]

export const INTERVALS = [4, 6, 8, 12, 24]

export const INCIDENTS = [
  { value: 'engasgo', label: 'Engasgo' },
  { value: 'refluxo', label: 'Refluxo' },
  { value: 'vomito', label: 'Vômito' }
]

export const OFFER_STATUS = {
  pendente: 'Pendente',
  atrasado: 'Atrasado',
  administrado: 'Administrado',
  parcial: 'Parcial',
  recusado: 'Recusado'
}

export function dietLabel(kind) {
  return DIET_KINDS.find((item) => item.value === kind)?.label || 'Dieta'
}

export function consistencyLabel(value) {
  return CONSISTENCIES.find((item) => item.value === value)?.label || ''
}

export function formatPlateItem(item) {
  const quantity = Number(item.quantity)
  const text = Number.isFinite(quantity)
    ? quantity.toLocaleString('pt-BR', { maximumFractionDigits: 2 })
    : item.quantity
  return `${item.food_name || item.foodName} (${text} ${item.unit})`
}

export function blankFood() {
  return { key: `food-${Date.now()}-${Math.random().toString(16).slice(2)}`, foodName: '', quantity: '', unit: 'g' }
}

export function routeLabel(route) {
  return ROUTES.find((item) => item.value === route)?.label || route || 'Via'
}

export function incidentLabel(value) {
  return INCIDENTS.find((item) => item.value === value)?.label || ''
}

export function stockLabel(item) {
  const stock = Math.round(Number(item.current_stock || 0) * 100) / 100
  const text = stock.toLocaleString('pt-BR', { maximumFractionDigits: 2 })
  const unit = UNIT_OPTIONS.find((option) => option.value === item.unit_type)
  const word = unit ? (stock === 1 ? unit.one : unit.many) : (item.unit_type || 'unidades')
  return `${text} ${word}`
}

export function scheduleLabel(item) {
  if (item.schedule_kind === 'horarios') return (item.dose_times || []).join(', ') || 'Horários'
  if (item.interval_hours && item.first_dose_time) return `${item.interval_hours}/${item.interval_hours}h a partir das ${item.first_dose_time}`
  return 'Horário'
}

export function shiftDate(iso, days) {
  const [year, month, day] = String(iso).split('-').map(Number)
  const date = new Date(year, month - 1, day)
  date.setDate(date.getDate() + days)
  const nextMonth = String(date.getMonth() + 1).padStart(2, '0')
  const nextDay = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${nextMonth}-${nextDay}`
}

export function dayHeading(iso) {
  const [year, month, day] = String(iso).split('-').map(Number)
  const label = new Date(year, month - 1, day).toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
  return iso === todayInputValue() ? `Hoje, ${label}` : label
}

export function todayInputValue() {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(new Date()).map((part) => [part.type, part.value]))
  return `${parts.year}-${parts.month}-${parts.day}`
}
